/**
 * Fills `{name}` placeholders. Callback-based, so a value with `$&`, `$1` or `$$` is inserted as is (a string
 * replacement would read those as patterns). Unknown placeholders stay.
 */
export function fill(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (m, k: string) => (Object.hasOwn(values, k) ? String(values[k]) : m));
}

/**
 * A link target from props: only `https:` or a same-origin path (`/…`, not `//…`), without backslashes,
 * whitespace or control characters. Anything else (javascript:, data:, http:, protocol-relative) is refused.
 */
export function safeHref(href: string | undefined): string | undefined {
  if (!href) return undefined;
  const h = href.trim();
  // eslint-disable-next-line no-control-regex -- refusing control characters is the point
  if (h !== href || /[\\\s\u0000-\u001f\u007f-\u009f]/.test(h)) return undefined;
  if (h.startsWith("/") && !h.startsWith("//")) return h;
  try {
    const u = new URL(h);
    return u.protocol === "https:" && !u.username && !u.password ? u.toString() : undefined;
  } catch {
    return undefined;
  }
}
